import { ActionReducerMap } from '@ngrx/store';
import { Campaign } from './../components/manager-home/model/CampaignModel';
import * as fromReducer from './reducer';

export interface AppState {
  campaign: Campaign;
}

export const appReducers: ActionReducerMap<AppState> = {
  campaign: fromReducer.reducer
}
